﻿import $ from 'jquery';
import { DefaultDocumentViewUi, DocumentDataPoll } from "./documentdatapoll";
import { PdfUrlBuilder } from './pdfurlbuilder';

declare global {
  interface JQuery {
    documentviewer: (option, args) => any;
  }
}

export class DocumentViewer {
  public static get wireup(): string {
    return '[data-documentviewer]'
  };

  public static show(url: string): void {
    let maxWidth = 1728; // 1920 * .90;
    let maxHeight = 972; // 1080 * .90;
    var scr: any = screen;

    let width = Math.round(screen.availWidth * .90);
    let height = Math.round(screen.availHeight * .90);
    if (width > maxWidth)
      width = maxWidth;
    if (height > maxHeight)
      height = maxHeight;

    var left = scr.availLeft + (screen.availWidth / 2) - (width / 2);
    var top = scr.availTop + (screen.availHeight / 2) - (height / 2);
    window.open(url, url, "width=" + width + ",height=" + height + ",left=" + left + ",top=" + top);
  }

  public static load($ui: JQuery): void {
    var url = new PdfUrlBuilder().build($ui.data().url);
    let $frame = $("<iframe id='view-document' src=" + url + "></iframe>");
    let $spinner = $('<div>').addClass('documentviewer-spinner');
    $ui.empty().append($spinner);
    $spinner.loading();
    $ui.append($frame);
  }

  public static poll($ui: JQuery) {
    var dataUrl = $ui.attr("data-documentdataurl");
    if (!dataUrl)
      throw new Error("You need a data URL. Check the Docs");
    var pollUrl = $ui.attr("data-documentpollurl");
    if (!pollUrl)
      throw new Error("You need a poll URL. Check the Docs");

    var ui = new DefaultDocumentViewUi(dataUrl, $ui);
    var poller = new DocumentDataPoll(pollUrl, ui);
    poller.view();
  }
}

$(document).on('click.rustig.documentviewer', '[data-documentlink]', function (e) {
  var $this = $(this);
  if ($this.data("url") || $this.attr("href"))
    throw Error("put your url in the data-documentlink attribute. You can't use href or data-url with documentlinks");
  var url = $this.data('documentlink');
  if (url)
    DocumentViewer.show(url);
});

function Plugin(options, args) {
  return this.each(function () {
    if ($(this).attr("data-documentviewer") === "poll")
      DocumentViewer.poll($(this));
    else
      DocumentViewer.load($(this));
  })
}

$.fn.documentviewer = Plugin;